import React from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import EuroSymbol from '@mui/icons-material/EuroSymbol';
import { CollapseCard } from '@totalsoft/rocket-ui';

const NoDataSummaryCard = ({ message }) => {
  const { t } = useTranslation();
  return <CollapseCard id={'staticCard'} toggleOnHeaderClick icon={EuroSymbol} title={t(message)} subheader={<>{t('NotApply')}</>} />;
};

NoDataSummaryCard.propTypes = {
  message: PropTypes.string.isRequired
};

export default NoDataSummaryCard;
